<template>
  <div
    class="confetti-tooltip"
    @mouseenter="showTooltip = true"
    @focus="showTooltip = true"
    @mouseleave="showTooltip = false"
    @blur="showTooltip = false"
  >
    <span class="confetti-tooltip__text" :class="`position-${position}`">
      {{ text }}
    </span>
    <slot />
  </div>
</template>

<script>
export const VALID_POSITIONS = [
  "top",
  "right",
  "bottom",
  "left",
  "bottom-left",
];

export default {
  name: "ConfettiTooltip",
  props: {
    position: {
      type: String,
      default: VALID_POSITIONS[0],
      validator: (position) => VALID_POSITIONS.includes(position),
    },
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showTooltip: false,
    };
  },
};
</script>

<style lang="scss" scoped>
/* stylelint-disable no-descending-specificity,max-nesting-depth */

@import "confetti/scss/variables/shadows";
@import "confetti/scss/variables/colors";

$tooltip-offset: 15px;

.confetti-tooltip {
  cursor: pointer;
  display: inline-block;
  position: relative;

  &:hover .confetti-tooltip__text {
    opacity: 1;
    visibility: visible;
  }
}

.confetti-tooltip__text {
  background-color: $kloeckner-white;
  box-shadow: $tooltip-box-shadow;
  color: $base-font-color;
  min-inline-size: 60px;
  opacity: 0;
  padding-block: 2px;
  padding-inline: 8px;
  position: absolute;
  text-align: center;
  transition: opacity 0.3s;
  visibility: hidden;
  white-space: nowrap;
  z-index: 1;

  &::after {
    border-color: $kloeckner-white transparent transparent transparent;
    border-style: solid;
    border-width: 1.2rem;
    content: "";
    position: absolute;
  }

  &.position-left {
    inset-inline-start: 0;
    transform: translate(calc(-100% - #{$tooltip-offset}), -15%);

    &::after {
      inset-block-start: 8%;
      inset-inline-start: 98%;
      transform: rotate(-90deg);
    }
  }

  &.position-right {
    inset-inline-end: 0;
    transform: translate(calc(#{$tooltip-offset} + 100%), -15%);

    &::after {
      inset-block-start: 8%;
      inset-inline-end: 98%;
      transform: rotate(90deg);
    }
  }

  &.position-top {
    inset-block-start: 0;
    transform: translate(-50%, -155%);

    &::after {
      inset-block-start: 98%;
      inset-inline-start: 34%;
    }
  }

  &.position-bottom {
    inset-block-end: 0;
    transform: translate(-50%, calc(#{$tooltip-offset} + 100%));

    &::after {
      inset-block-end: 98%;
      inset-inline-start: 34%;
      transform: rotate(180deg);
    }
  }

  &.position-bottom-left {
    inset-block-end: 0;
    inset-inline-start: 0;
    transform: translate(-80%, calc(#{$tooltip-offset} + 100%));

    &::after {
      inset-block-end: 98%;
      inset-inline-start: 65%;
      transform: rotate(180deg);
    }
  }
}
</style>
